import { SS_TRANSACTION_KEY, SS_TILIA_CALLBACK } from '@config/localstorage.js'
import { useSessionStorage } from '@vueuse/core'
import { isObj } from '@helpers/utils.js'
import { computed } from 'vue'

const transactionKeyState = useSessionStorage(SS_TRANSACTION_KEY, '{}')
const tiliaCallbackState = useSessionStorage(SS_TILIA_CALLBACK, '{}')

export default function () {
  const transactionKey = computed(() => JSON.parse(transactionKeyState.value))
  const tiliaCallback = computed(() => JSON.parse(tiliaCallbackState.value))

  function setTiliaCallback(key, value) {
    tiliaCallbackState.value = JSON.stringify({
      ...tiliaCallback.value,
      [key]: value,
    })
  }

  function setTransactionKey(gameId, secondId, value) {
    const update = isObj(transactionKey.value)
      ? { ...transactionKey.value }
      : {}
    const key = `${gameId}-${secondId}`
    if (value) {
      update[key] = `${key}-${value}`
    } else {
      delete update[key]
    }
    transactionKeyState.value = JSON.stringify(update)
  }

  return {
    setTransactionKey,
    setTiliaCallback,
    transactionKey,
    tiliaCallback,
  }
}
